import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import { ClipboardList, LayoutDashboard, ExternalLink, LogOut } from "lucide-react";
import { useAuth } from "@/lib/auth";

export default function AuditLayout() {
  const loc = useLocation();
  const nav = useNavigate();
  const { user, logout } = useAuth();
  const doLogout = async () => { await logout(); nav("/audit/login", { replace: true }); };
  return (
    <div data-surface="audit" className="min-h-screen bg-[hsl(var(--audit-bg))] text-[hsl(var(--audit-text))]">
      <div className="grid min-h-screen grid-cols-[240px_1fr]">
        <aside className="border-r border-[hsl(var(--audit-border))] bg-white">
          <div className="border-b border-[hsl(var(--audit-border))] px-5 py-5">
            <div className="text-xs uppercase tracking-[0.25em] text-[hsl(var(--audit-muted))]">Panel</div>
            <div className="mt-1 text-lg font-bold tracking-tight">Audit Framework</div>
          </div>
          <nav className="p-3">
            <Link
              to="/audit"
              data-testid="sidebar-audits-link"
              className={`flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium ${
                loc.pathname === "/audit" ? "bg-[hsl(var(--audit-bg))]" : "hover:bg-[hsl(var(--audit-bg))]"
              }`}
            >
              <ClipboardList size={16} /> Auditorías
            </Link>
            <Link
              to="/"
              data-testid="sidebar-clinic-link"
              className="mt-1 flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium text-[hsl(var(--audit-muted))] hover:bg-[hsl(var(--audit-bg))]"
            >
              <LayoutDashboard size={16} /> Web pública <ExternalLink size={12} className="ml-auto" />
            </Link>
          </nav>
          <div className="mt-8 px-5 text-xs text-[hsl(var(--audit-muted))]">
            <div className="font-mono uppercase tracking-widest">Framework · 8 fases</div>
            <ol className="mt-2 space-y-1 font-mono">
              {["Matriz de Evidencias","Auditoría forense","Benchmark","E-E-A-T","GEO","Puntuación","Riesgo/Beneficio","Backlog"].map((s,i) => (
                <li key={s}>{String(i+1).padStart(2,"0")} · {s}</li>
              ))}
            </ol>
          </div>
          {user && (
            <div className="mt-8 border-t border-[hsl(var(--audit-border))] px-5 py-4">
              <div className="text-xs font-mono text-[hsl(var(--audit-muted))]">Sesión</div>
              <div className="mt-1 truncate text-sm font-semibold" data-testid="audit-user-email">{user.email}</div>
              <button onClick={doLogout} data-testid="audit-logout-btn" className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-red-700 hover:underline">
                <LogOut size={12} /> Cerrar sesión
              </button>
            </div>
          )}
        </aside>
        <main>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
